import type { ExtendedSeriesOptionsType } from '@/features/_shared/chart/types/highcharts';

import type Highcharts from 'highcharts/highstock';
import type { Theme } from '@/shared/ui';

import { GX_TEXT, GX_TILE_LIGHT } from '@/config/colors';
import { clock } from '@/services/clock';

const createRangeSelector = (
  theme: Theme,
  chartSeries: ExtendedSeriesOptionsType[]
): Highcharts.RangeSelectorOptions => {
  return {
    labelStyle: {
      display: 'none'
    },
    x: -30,
    buttonSpacing: 8,
    buttonTheme: {
      height: 22,
      width: 40,
      r: 0,
      fill: GX_TILE_LIGHT,
      style: {
        color: GX_TEXT
      },
      states: {
        disabled: {
          style: {
            color: 'rgba(255, 255, 255, 0.3)'
          },
          fill: 'rgba(255, 255, 255, 0.12)'
        },
        hover: {
          style: {
            color: theme.palette.gx.textSecondary
          }
        },
        select: {
          fill: theme.palette.gx.highlight,
          style: {
            color: GX_TEXT
          }
        }
      }
    },
    buttons: [
      {
        type: 'month',
        count: 3,
        text: '3m'
      },
      {
        type: 'year',
        count: 1,
        text: '1y'
      },
      {
        type: 'year',
        count: 5,
        text: '5y'
      },
      {
        type: 'all',
        text: 'Max'
      }
    ],
    selected: determineTimerangeButtonIndex(chartSeries),
    inputEnabled: false
  };
};

function isOneYearBefore(timestamp: number) {
  const currentDate = clock.date();
  const oneYearAgo = clock.date();

  oneYearAgo.setFullYear(currentDate.getFullYear() - 1);
  const timestampDate = new Date(timestamp);

  return timestampDate < oneYearAgo;
}

function determineTimerangeButtonIndex(
  chartSeries: ExtendedSeriesOptionsType[]
): number | undefined {
  const anySeriesLongerThanYear = chartSeries.find(series => {
    if (series.data[0]?.x) {
      return isOneYearBefore(series.data[0].x);
    }
  });
  return anySeriesLongerThanYear ? 1 : undefined;
}

export default createRangeSelector;
